import { useFormatter, useTranslations } from "next-intl";

export interface TimeSelectorProps {
  selectedTime: Date | null;
  availableTimeSlots: Date[];
  timezone?: string;
  className?: string;
  onSelect: (timeSlot: Date) => void;
}

export function TimeSelector({
  selectedTime,
  availableTimeSlots,
  timezone,
  className,
  onSelect,
}: Readonly<TimeSelectorProps>) {
  const t = useTranslations("TimeSelector");
  const format = useFormatter();
  const formatTime = (date: Date) => {
    return format.dateTime(date, "timeNumeric", {
      timeZone: timezone,
    });
  };

  return (
    <div className={className}>
      {/* Time Slots Grid */}
      {availableTimeSlots.length > 0 ? (
        <div className="grid grid-cols-3 gap-3">
          {availableTimeSlots.map((timeSlot, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onSelect(timeSlot)}
              data-testid={`time-slot-${index}`}
              className={`rounded-lg border border-purple-600 px-4 py-2 text-center text-sm font-medium transition-colors cursor-pointer ${
                selectedTime?.getTime() === timeSlot.getTime()
                  ? "bg-purple-600 text-white"
                  : "bg-white text-purple-600 hover:bg-purple-50 dark:border-purple-400 dark:bg-zinc-800 dark:text-purple-400 dark:hover:bg-purple-400/10"
              }`}
            >
              {formatTime(timeSlot)}
            </button>
          ))}
        </div>
      ) : (
        <div className="text-center text-zinc-500 dark:text-zinc-400">
          {t("noAvailableTimeSlots")}
        </div>
      )}
    </div>
  );
}
